import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { storePlantRowData } from "../Store/TemplateStore/template.action";
import { useTranslation } from "react-i18next";

import { sharePlant, unsharePlant, getPlants } from "../network/cipAPI";

import DupontDialog from "../components/DupontDialog";
import InputBox from "../components/InputBox";
import createNotification, {
  SUCCESS_NOTIFICATION,
  ERROR_NOTIFICATION,
} from "../components/Notifications";

import "./index.scss";

const ShareDialog = ({ setShareDialogOpen, shareDialogOpen, plantId }) => {
  const { t } = useTranslation();

  const [showOverlayLoader, setShowOverlayLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [comments, setComments] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const dispatch = useDispatch();
  const getPlantDetails = async () => {
    try {
      const response = await getPlants();
      if (response && response.data) {
        dispatch(storePlantRowData(response.data));
      } else {
        dispatch(storePlantRowData([]));
      }
    } catch (err) {
    } finally {
    }
  };

  const handleConfirm = async () => {
    setShowOverlayLoader(true);
    try {
      const payload = { shared_email: email, comments };
      const response = await sharePlant(plantId, payload);

      if (response && response.message) {
        setShareDialogOpen(false);
        createNotification(SUCCESS_NOTIFICATION, response.message, "");
        getPlantDetails();
      } else {
        createNotification(ERROR_NOTIFICATION, response.detail.error, "");
        setErrorMsg(response.detail.error);
      }
    } catch (error) {
      console.error("Error during sharing plant:", error);
    } finally {
      setShowOverlayLoader(false);
    }
  };

  const handleUnshare = async () => {
    setShowOverlayLoader(true);
    try {
      const response = await unsharePlant(plantId, email);
      if (response && response.message) {
        setShareDialogOpen(false);
        createNotification(SUCCESS_NOTIFICATION, response.message, "");
        getPlantDetails();
      } else {
        createNotification(ERROR_NOTIFICATION, response.detail.error, "");
        setShareDialogOpen(false);
      }
    } catch (error) {
      console.error("Error during sharing plant:", error);
    } finally {
      setShowOverlayLoader(false);
    }
  };
  const onClose = (action) => {
    if (action === "CONFIRM") {
      handleConfirm();
    } else if (action === "CANCEL") {
      setShareDialogOpen(false);
    }
  };

  const handleChange = (value) => {
    setEmail(value);
    if (value.trim() === "") {
      setErrorMsg(t("sharePlant.emptyErrorMessage"));
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setErrorMsg([t("sharePlant.invalidEmail")]);
    } else {
      setErrorMsg("");
    }
  };
  const handleCommentsChange = (value) => {
    setComments(value);
  };

  return (
    <>
      <DupontDialog
        open={shareDialogOpen}
        onClose={onClose}
        cancelBtn={t("ValueStrings.cancel")}
        title={t("sharePlant.title")}
        subTitle={t("sharePlant.subTitle")}
        confirmBtnText={t("ValueStrings.share")}
        maxwidth="xl"
        minWidth={500}
        isOverlayLoader={showOverlayLoader}
        unShareDisabled={!email}
        customHeight={"350px"}
        confirmDisabled={!email || errorMsg}
      >
        <div>
          <div className="share">
            {t("sharePlant.userMsg")} <span style={{ color: "red" }}>*</span>
          </div>
          <InputBox
            placeholder={t("sharePlant.enterEmail")}
            onChange={handleChange}
            maxLength={254}
          />

          <div
            style={{
              color: errorMsg ? "red" : "grey",
              textAlign: "left",
              marginTop: "10px",
            }}
          >
            {errorMsg || t("sharePlant.roUser")}
          </div>
          <div className="share marginTop10">{t("sharePlant.comments")}</div>
          <InputBox
            placeholder={t("sharePlant.comments")}
            rows={3}
            maxLength={225}
            onChange={handleCommentsChange}
          />
        </div>
      </DupontDialog>
    </>
  );
};

export default ShareDialog;
